import { EmptySearchIcon } from '@modules/common/components/EmptySearchIcon';
import { Stack, Typography } from '@mui/material';

interface NoDataFoundProps {
  title: string;
}

export const NoDataFound = ({ title }: NoDataFoundProps) => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <EmptySearchIcon width={80} height={80} />
      <Typography variant="body1" color="warning.light">
        {title}
      </Typography>
    </Stack>
  );
};
